export default "__VITE_ASSET__BdnCRvkj__"